import { BsCashCoin, BsTicketPerforated } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { MdMiscellaneousServices, MdOutlineDashboard, MdOutlineWork, MdOutlineMessage, MdOutlinePayments } from "react-icons/md";
import { FiFileText, FiCheckSquare, FiSettings, FiMessageSquare, FiDollarSign, FiEdit2 } from "react-icons/fi";
import { RiExchangeDollarLine, RiMessageLine } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import DashboardSettings from "../screens/Dashboard/DashboardSettings";
import JobDone from "../screens/Dashboard/JobDone";
import JobDoneDetails from "../screens/Dashboard/JobDoneDetails";
import JobRequest from "../screens/Dashboard/JobRequest";
import QuoteRequestDetail from "../screens/Dashboard/QuoteRequestDetail";
import PaymentRequest from "../screens/Dashboard/PaymentRequest/PaymentRequest";
import DashboardHome from "../screens/Dashboard/VendorDashboard/DashboardHome";
import ProContract from "../screens/Dashboard/ProContract/ProContract";
import DashboardUserSide from "../screens/UserDashboard/DashboardUserSide";
import SimpleMessages from "../screens/UserDashboard/SimpleMessages";
import MyJobs from "../screens/UserDashboard/MyJobs";
import SettingsUser from "../screens/UserDashboard/SettingsUser";
import Subscription from "../screens/UserDashboard/Subscription";
import ServicesPage from "../screens/UserDashboard/Service";
import SupportTickets from "../screens/UserDashboard/SupportTickets";

export const logoutPage = () => {
  return;
};

export const userDashboardRoutes = [
  {
    caption: "Dashboard",
    linkTo: "/",
    icon: <MdOutlineDashboard size={22} />,
    element: <DashboardHome />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Job Requests",
    linkTo: "/job-req",
    icon: <FiFileText size={22} />,
    element: <JobRequest />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Jobs",
    linkTo: "/job-done",
    icon: <FiCheckSquare size={22} />,
    element: <JobDone />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Job Done Details",
    linkTo: "/job-done/:id",
    icon: <FiCheckSquare size={22} />,
    element: <JobDoneDetails />,
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Quote Request Detail",
    linkTo: "/quote-request/:id",
    icon: <FiFileText size={22} />,
    element: <QuoteRequestDetail />,
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },

  {
    caption: "Messages",
    linkTo: "/message",
    icon: <FiMessageSquare size={22} />,
    element: <SimpleMessages />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Payments",
    linkTo: "/payment-request",
    icon: <FiDollarSign size={22} />,
    element: <PaymentRequest />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Settings",
    linkTo: "/settings",
    icon: <FiSettings size={22} />,
    element: <DashboardSettings />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Provider Agreement",
    linkTo: "/contract",
    icon: <FiEdit2 size={22} />,
    element: <ProContract />,
    list_in_sidebar: true,
    both: false,
    admin: true,   // pro-only
    user: false,
  },
];

export const userFromUserSideRoutes = [
  {
    caption: "Dashboard",
    linkTo: "/",
    icon: <MdOutlineDashboard size={22} />,
    element: <DashboardUserSide />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Services",
    linkTo: "/services",
    icon: <MdMiscellaneousServices size={22} />,
    element: <ServicesPage />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "My Jobs",
    linkTo: "/myjobs-user",
    icon: <MdOutlineWork size={22} />,
    element: <MyJobs />,
    both: false,
    list_in_sidebar: true,
    admin: true,
    user: false,
  },
  {
    caption: "Messages",
    linkTo: "/message-user",
    icon: <FiMessageSquare size={22} />,
    element: <SimpleMessages />,
    admin: true,
    list_in_sidebar: true,
    both: false,
    user: false,
  },
  {
    caption: "Settings",
    linkTo: "/settings",
    icon: <FiSettings size={22} />,
    element: <SettingsUser />,
    user: false,
    list_in_sidebar: true,
    both: false,
    admin: true,
  },
  {
    caption: "Membership",
    linkTo: "/subscriptions",
    icon: <RiExchangeDollarLine size={22} />,
    element: <Subscription />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Support",
    linkTo: "/support-tickets",
    icon: <BsTicketPerforated size={22} />,
    element: <SupportTickets />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
];
